// Shared horse-name matching for the Results search and the last-result lookup.
// Mirrors racing/name_match.py: both must give identical output, and both test
// suites read racing/tests/fixtures/name_match_cases.json.

const COUNTRY_SUFFIX = /\s*\([a-z]{2,3}\)\s*$/;
const APOSTROPHES_AND_DOTS = /['‘’.]/g;
const HYPHENS_AND_SLASHES = /[-‐‑‒–—/]/g;
const OTHER_PUNCTUATION = /[^\p{L}\p{N}\s]/gu;
const SPACES = /\s+/g;

export function normaliseName(s) {
  if (s == null) return '';
  return String(s)
    .normalize('NFKD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(COUNTRY_SUFFIX, '')
    .replace(APOSTROPHES_AND_DOTS, '')
    .replace(HYPHENS_AND_SLASHES, ' ')
    .replace(OTHER_PUNCTUATION, '')
    .replace(SPACES, ' ')
    .trim();
}

export function nameMatches(query, name) {
  const q = normaliseName(query);
  if (q === '') return false;
  return normaliseName(name).includes(q);
}
